export default __webpack_public_path__ + "static/media/Settings_OK.02bfe433.svg";